module.exports = __webpack_public_path__ + "static/media/sponsor_desktop.857b0818.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sponsor_desktop.svg
// module id = 1177
// module chunks = 0